import React from "react";
import WeekDayButton from "../Button/WeekDayButton";

export default function AvailabilityEditor({
  t,
  parsedUserProfile,
  transform_timezone,
  dayArray,
  hoursArray,
  initialBookedSlots,
  selectedSlots,
  toggleSlot,
  saveTimeSlots,
}) {
  return (
    <div className="flex flex-col gap-6">
      <p className="text-lg md:text-xl">
        {t("user_home.add_day_avail_1")}{" "}
        <span className="text-red-600">
          {t(transform_timezone(parsedUserProfile?.timezone))}
        </span>{" "}
        {t("user_home.add_day_avail_2")}
      </p>
      <div className="overflow-x-auto pt-4 px-2">
        <div className="flex space-x-4 min-w-max">
          {dayArray.map((day) => (
            <div key={day} className="flex flex-col items-center">
              <WeekDayButton name={day} nowState="" />
              <div className="flex flex-col space-y-1 pt-2">
                {hoursArray.map((hour) => {
                  const isInitialSlot = initialBookedSlots.some(
                    (s) => s.day === day && s.time === hour
                  );
                  const isSelectedSlot = selectedSlots.some(
                    (s) => s.day === day && s.time === hour
                  );

                  return (
                    <button
                      key={`${day}-${hour}`}
                      onClick={() => toggleSlot(day, hour)}
                      className={`text-center py-1 px-2 text-md border font-semibold ${
                        isInitialSlot
                          ? isSelectedSlot
                            ? "bg-gray-50"
                            : "bg-[var(--brand)] text-white"
                          : isSelectedSlot
                          ? "bg-[var(--brand)] text-white"
                          : "bg-gray-50"
                      }`}
                    >
                      {hour}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center mt-5">
          <button
            className="flex items-center hover:bg-[#005d34] bg-[var(--brand)] rounded-[5px] px-[100px] py-[8px] text-white"
            onClick={saveTimeSlots}
          >
            {t("generic.update")}
          </button>
        </div>
      </div>
    </div>
  );
}
